import { useEffect, useRef } from 'react'

import { useOverlayHost } from '@aeris/ui'

/**
 * Quem recebe o bipe que caiu fora de um campo — F206.
 *
 * O PDV e as Etiquetas já sabiam o que fazer com um código; só perdiam o bipe
 * quando o foco saía do campo (um clique no carrinho, um diálogo fechado). A
 * tela registra aqui o que faz com um código, e o leitor global entrega a ela
 * em vez de abrir a venda ou o produto.
 *
 * Uma pilha, e não um valor: a última tela montada é a dona. Um diálogo que
 * registra por cima do PDV devolve a posse ao fechar.
 */

type Owner = {
  readonly handle: (code: string) => void
  /** A janela do Modo PC deste dono é a da frente? Fora de janela, sempre. */
  readonly isActive: () => boolean
}

const owners: Owner[] = []

/*
 * O bipe vai para a janela da frente (F212).
 *
 * Era o último dono montado: com o PDV e o Atendimento abertos no Modo PC, o
 * código lido com o PDV na frente caía na tela que abriu por último.
 */
export const currentScanOwner = (): ((code: string) => void) | null =>
  (owners.findLast((owner) => owner.isActive()) ?? owners.at(-1))?.handle ??
  null

export const useScanOwner = (
  handle: (code: string) => void,
  enabled = true
): void => {
  const host = useOverlayHost()
  const hostRef = useRef(host)
  const latest = useRef(handle)
  useEffect(() => {
    latest.current = handle
    hostRef.current = host
  })

  useEffect(() => {
    if (!enabled) return
    const owner: Owner = {
      handle: (code) => {
        latest.current(code)
      },
      isActive: () => hostRef.current?.isActive?.() ?? true,
    }
    owners.push(owner)
    return () => {
      const index = owners.indexOf(owner)
      if (index !== -1) owners.splice(index, 1)
    }
  }, [enabled])
}
